function n(n,r){return n.map((n=>n*r))}export{n as convertOffsetToTimes};
